import { Component, Inject, OnInit } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { StatusConstant } from '../status/status-constant';
import { LoaderService } from '../../shared/loader/loader.service';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { DatePipe } from '@angular/common';
import { animate, state, style, transition, trigger } from '@angular/animations';
import * as moment from 'moment';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Observable } from 'rxjs/internal/Observable';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../reusableComponents/confirm-dialog/confirm-dialog.component';
import { MatRadioChange } from '@angular/material/radio';
import { Clipboard } from "@angular/cdk/clipboard";
import { SendEmailNotificationComponent } from '../sendEmailNotification/sendEmailNotification.component';
import { FormAuditType, ProjectTempType } from '../Enum/common.enum';
import { GroupType } from 'src/app/applicationModules/core/services/coreService/core.enum';
import { DataSharingService } from '../resuableServices/data-sharing.service';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { Add3ctypeformComponent } from '../add3ctypeform/add3ctypeform.component';
import { map, startWith } from 'rxjs/operators';
export interface State {
  name: string;
  email: string;
  role: string;
  pic: string;
}
@Component({
  selector: 'app-createProjects',
  templateUrl: './createProjects.component.html',
  styleUrls: ['./createProjects.component.scss'],
})

export class CreateProjectsComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  formDialog: FormGroup;
  spinner: boolean = false;
  OfficeIDList: any = [];
  myOfficeID: any;
  getassign: any;
  SendButtonDisabled: boolean = false;
  NormalContacts: any = [];
  SharedContacts: any = [];
  MatchingRole: any = [];
  projectGroups: any = [] = [];
  participantMessageInfo: string = null;
  ProjectIdForEdit: string = "";
  projectID: number = 0;
  eventLogMessage: string = "";
  toogleInformation = true;
  ipAddress: any;
  browsername: any;
  device: any;
  ContactNames: string = "";

  constructor(public dialogRef: MatDialogRef<CreateProjectsComponent>,
    private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private coreService: CoreService,
    private toastr: ToastrService, private statusConstant: StatusConstant,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private loaderService: LoaderService, private dialog: MatDialog,
    private clipboard: Clipboard, private _dataSharingService: DataSharingService,
    private http: HttpClient, private httpBackend: HttpBackend,) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
    var skipInterceptor = new HttpClient(httpBackend);
    skipInterceptor.get<{ ip: string }>('https://api.ipify.org?format=json').subscribe(data => {
      this.ipAddress = data.ip
    });
    this.stateCtrl.setValue(this.stateCtrlValue);
    this.filteredStates = this.stateCtrl.valueChanges.pipe(
      startWith(''),
      map((state) => (state ? this._filterStates(state) : this.states.slice()))
    );
  }

  private _filterStates(value: string): State[] {
    const filterValue = value.toLowerCase();
    return this.states.filter((state) => state.name.toLowerCase().indexOf(filterValue) === 0);
  }

  ngOnInit(): void {
    this.getassign = this.data.document;
    this.SendButtonDisabled = false;
    this.getNormalAndSharedContacts(this.data.document);
  }

  getNormalAndSharedContacts(document) {
    var ReqModel = {
      DatabaseID: Number(this.databaseId),
      OrganizationID: Number(this.organizationId),
      UserID: this.currentUser.UID,
      CoreID: Number(this.data.transactionID)
    }
    this.coreService.getNormalAndSharedContacts(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.MatchingRole = [];
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.NormalContacts = response.data.contactListModel.filter((x:any) => x.contactCoreRoleMappingModels.length > 0);
          if (this.NormalContacts.length > 0) {
            for (var i = 0, len = this.NormalContacts.length; i < len; ++i) {
              var contactCoreRoleMappingModels = [];
              contactCoreRoleMappingModels = this.NormalContacts[i].contactCoreRoleMappingModels;
              if (contactCoreRoleMappingModels.length > 0) {
                for (var i1 = 0, len1 = contactCoreRoleMappingModels.length; i1 < len1; ++i1) {
                  var ReqModel = {
                    contactID: this.NormalContacts[i].contactID,
                    email: this.NormalContacts[i].email,
                    name: this.NormalContacts[i].name,
                    roleName: contactCoreRoleMappingModels[i1].rloeName
                  }
                  this.MatchingRole.push(ReqModel);
                }
              }
              else {
              }
            }

          }

          this.SharedContacts = response.data.sharedContactListModel.filter((x:any) => x.contactCoreRoleMappingModels.length > 0);

          if (this.SharedContacts.length > 0) {

            for (var i = 0, len = this.SharedContacts.length; i < len; ++i) {
              var contactCoreRoleMappingModels = [];
              contactCoreRoleMappingModels = this.SharedContacts[i].contactCoreRoleMappingModels;
              if (contactCoreRoleMappingModels.length > 0) {
                for (var i1 = 0, len1 = contactCoreRoleMappingModels.length; i1 < len1; ++i1) {
                  var ReqModel = {
                    contactID: this.SharedContacts[i].contactID,
                    email: this.SharedContacts[i].email,
                    name: this.SharedContacts[i].name,
                    roleName: contactCoreRoleMappingModels[i1].rloeName
                  }
                  this.MatchingRole.push(ReqModel);
                }
              }
              else {
              }
            }
          }
          this.AddCreateProjectforPlaceholder(document)
        } else {
        }
      }
      else {
      }
    });
  }

  AddCreateProjectforPlaceholder(document) {
    this.projectGroups = [];
    var ReqModel = {
      transactionID: Number(this.data.transactionID),
      documentFolderID: document.documentFolderID,
      formID: document.formID,
      formType: FormAuditType.NormalForm,
      placeholderID: document.placeholderID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      OfficeID: this.myOfficeID,
      taskID: document.taskID,
      projectID: document.projectID
    }
    this.loaderService.show();
    this.coreService.AddCreateProjectforPlaceholder(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;

        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.projectGroups = this.responseHolder.data.participants;//this.responseHolder.data;
          if (this.projectGroups == null) {
            this.projectGroups = [];
          }
          if (this.projectGroups.length > 0) {
            this.participantMessageInfo = this.projectGroups[0].participantMessageInfo;

            for (var i = 0, lennew = this.projectGroups.length; i < lennew; ++i) {
              // this.projectGroups[i].projGrpRelationParticipantList = this.projectGroups[i].projGrpRelationParticipantList.filter(m => m.isApprover != true);
              this.projectGroups[i].projGrpRelationParticipantList = this.projectGroups[i].projGrpRelationParticipantList;
            }
            for (var i = 0, lennew = this.projectGroups.length; i < lennew; ++i) {
              var projGrpRelationParticipantList = [];
              projGrpRelationParticipantList = this.projectGroups[i].projGrpRelationParticipantList;
              if (projGrpRelationParticipantList.length > 0) {
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                  var matchRole = [];
                  matchRole = this.MatchingRole.filter(m => m.roleName == projGrpRelationParticipantList[i1].relationName);
                  if (matchRole.length > 0) {
                    this.projectGroups[i].projGrpRelationParticipantList[i1].selectedContactFieldEmailID = matchRole;
                  } else {
                    this.projectGroups[i].projGrpRelationParticipantList[i1].selectedContactFieldEmailID = [];
                  }
                }
              }
              else {
              }
            }
          }


          if (this.projectGroups.length > 0) {
            this.ProjectIdForEdit = this.projectGroups[0].projectID;
            this.projectID = this.projectGroups[0].projectID;
          }

          var data = [];
          data = this.projectGroups;
          if (data.length > 0) {
            this.eventLogMessage = "Sent for signature to ";
            var checkGroup = this.projectGroups.filter(m => m.groupType == GroupType.Group);
            if (checkGroup.length > 0) {
              var projGrpRelationParticipantList = [];
              projGrpRelationParticipantList = checkGroup[0].projGrpRelationParticipantList;
              for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                var checkEmailAnonmous = projGrpRelationParticipantList[i1].contactEmail;
                var checkEmail = projGrpRelationParticipantList[i1].participantEmail;
                var email = "";
                if (checkEmailAnonmous != "") {
                  email = checkEmailAnonmous;
                  this.eventLogMessage += '(' + email + '), ';
                }
                if (checkEmail != "") {
                  email = checkEmail;
                  this.eventLogMessage += '(' + email + '), ';
                }
              }
            }

            var checkViewOnly = this.projectGroups.filter(m => m.groupType == GroupType.ViewOnly);
            if (checkViewOnly.length > 0) {
              for (var i = 0, len4 = checkViewOnly.length; i < len4; ++i) {
                var projGrpRelationParticipantList = [];
                projGrpRelationParticipantList = checkViewOnly[i].projGrpRelationParticipantList;
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                  var checkEmailAnonmous = projGrpRelationParticipantList[i1].contactEmail;
                  var checkEmail = projGrpRelationParticipantList[i1].participantEmail;
                  var email = "";
                  if (checkEmailAnonmous != "") {
                    email = checkEmailAnonmous;
                    this.eventLogMessage += '(' + email + '), ';
                  }
                  if (checkEmail != "") {
                    email = checkEmail;
                    this.eventLogMessage += '(' + email + '), ';
                  }
                }
              }
            }
          }

          this.eventLogMessage = this.eventLogMessage?.replace(/,\s*$/, "") || "";

          var check = [];
          if (this.responseHolder.data.participants == null) {
            this.responseHolder.data.participants = [];
          }
          check = this.responseHolder.data.participants.filter((x:any) => x.groupType === GroupType.Group);//this.responseHolder.data.filter((x:any) => x.groupType === 1);
          if (check.length > 0) {
            for (var i = 0, len = check.length; i < len; ++i) {
              var projGrpRelationParticipantList = [];
              projGrpRelationParticipantList = check[i].projGrpRelationParticipantList;
              if (projGrpRelationParticipantList.length > 0) {
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                  if (projGrpRelationParticipantList[i1].participantEmail == null) {
                    projGrpRelationParticipantList[i1].participantEmail = '';
                  }
                  if (projGrpRelationParticipantList[i1].coreID > 0 || projGrpRelationParticipantList[i1].contactID > 0 ||
                    projGrpRelationParticipantList[i1].companyID > 0 || projGrpRelationParticipantList[i1].pUserID > 0 ||
                    projGrpRelationParticipantList[i1].roleID > 0 || projGrpRelationParticipantList[i1].participantEmail != '')
                  // if (projGrpRelationParticipantList[i1].contactEmail != "" ||
                  //   projGrpRelationParticipantList[i1].participantEmail != "" ||
                  //   projGrpRelationParticipantList[i1].roleID != "0") 
                  {
                    this.SendButtonDisabled = true;
                    this.loaderService.hide();
                    return;
                  } else {
                    this.SendButtonDisabled = false;
                    // return;
                  }
                }
              }
              else {
              }
            }
          }

        } else {
          this.loaderService.hide();
          this.projectGroups = [];
          //this.dialog.closeAll();
        }
      } else {
        this.loaderService.hide();
        this.projectGroups = [];
        //this.dialog.closeAll();
      }
    });

  }

  closeSelectParticipant() {
    this.dialogRef.close('Added');
  }

  getToogleInformation() {
    this.toogleInformation = !this.toogleInformation;
  }

  getShortName(fullName) {
    return fullName.split(' ').map(n => n[0]).join('');
  }

  openProject() {
   // this.dialog.closeAll();
    sessionStorage.setItem('projectID', this.ProjectIdForEdit);
    sessionStorage.setItem('type', (ProjectTempType.Project).toString()); // 1 for Project and 2 for Template
    sessionStorage.setItem('ImportTemplateShow', 'true');
    sessionStorage.setItem('MasterTemplatePDFForm', 'false');
    sessionStorage.setItem('MasterTemplateTabularForm', 'false');
    sessionStorage.setItem('MasterOrgTemplatePDFForm', 'false');
    sessionStorage.setItem('MasterTemplateWebForm', 'false');
    this._dataSharingService.sendSelectedProjectName("");
    let links = window.location.href.split(window.location.pathname)[0] + "/esignature/third"
    window.open(links, "_blank");
    sessionStorage.setItem('HeaderModuleName', 'Forms');
    this._dataSharingService.sendSelectedModuleName('Forms');
    this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);
  }

  ProjectSend() {
    var ReqModel = {
      folderId: 1,
      projectId: this.ProjectIdForEdit,
      projectName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      type: 1,  // 1 Form Send , 2 Sand an Save , 3 Save Template Only 
      fileManagerFolderId: 0,
      OfficeID: this.myOfficeID
    }
    this.loaderService.show()
    this.coreService.AddProjectInfoAsTemplete(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
          this.loaderService.hide();
          this.AddProjectEventLog();
          this.toastr.success('Form has sent successfully to participants.', '', {
            timeOut: 3000,
          });
          this.dialogRef.close('Added');
          //this.getAllFolders();
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  // To Add Project EventLog //
  async AddProjectEventLog() {
    try {
      var ReqModel = {
        projectID: this.ProjectIdForEdit,
        ipAddress: this.ipAddress,
        message: this.eventLogMessage,
        eventType: 1, //Sent=1, View=2, Sign=3, Complete=4, Decline=5, Assign=6
        device: this.device,
        browser: this.browsername,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId),
      }
      const result = await this.coreService.AddProjectEventLog(ReqModel).toPromise();
      this.responseHolder = result;
      if (this.responseHolder.status === this.statusConstant.statusSuccess) {
      } else {
        this.loaderService.hide();
      }
    } catch (e) {
      Observable.throw(e);
    }
  }

  // Remove Relation 
  RemoveRelation(group, p) {
    const message = `Are you sure you want to delete this participant?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          this.loaderService.show();
          if (group !== undefined) {
            var relationListModels = [];
            var ReqModel = {
              groupRelationParticipantMappingID: group.groupRelationParticipantMappingID,
              groupID: group.groupID,
              relationColour: group.relationColour,
              contactID: null,
              relationID: group.relationID,
              projectID: this.projectID,//p.projectID,//sessionStorage.getItem('projectID'),
              roleID: null,
              typeOfParticipant: group.typeOfParticipant
            }
            relationListModels.push(ReqModel)

            var ReqModels = {
              relationListModels: relationListModels,
              userID: this.currentUser.UID,
              databaseID: Number(this.databaseId),
              organizationID: Number(this.organizationId),
              type: p.type,//Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
              OfficeID: this.myOfficeID
            }
            this.coreService.AddEditProjectGroupRelationParticipant(ReqModels).subscribe((response) => {
              if (response != undefined) {
                this.responseHolder = response;
                if (this.responseHolder.status == this.statusConstant.statusSuccess) {
                  this.loaderService.hide();
                  this.AddRemoveParticipant(this.getassign);
                  this.toastr.success('Participant removed successfully', '', {
                    timeOut: 3000,
                  });
                } else {
                  this.loaderService.hide();
                }
              } else {
                this.loaderService.hide();
              }
            });
          }
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  AddRemoveParticipant(document) {
    var ReqModel = {
      transactionID: Number(this.data.transactionID),
      documentFolderID: document.documentFolderID,
      formID: document.formID,
      formType: FormAuditType.NormalForm,
      placeholderID: document.placeholderID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      OfficeID: this.myOfficeID,
      taskID: document.taskID,
      projectID: this.projectID//document.projectID
    }
    this.loaderService.show();
    this.coreService.AddCreateProjectforPlaceholder(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.projectGroups = this.responseHolder.data.participants;//this.responseHolder.data;
          if (this.projectGroups == null) {
            this.projectGroups = [];
          }
          if (this.projectGroups.length > 0) {
            for (var i = 0, lennew = this.projectGroups.length; i < lennew; ++i) {
              var projGrpRelationParticipantList = [];
              projGrpRelationParticipantList = this.projectGroups[i].projGrpRelationParticipantList;
              if (projGrpRelationParticipantList.length > 0) {
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                  var matchRole = [];
                  matchRole = this.MatchingRole.filter(m => m.roleName == projGrpRelationParticipantList[i1].relationName);
                  if (matchRole.length > 0) {
                    this.projectGroups[i].projGrpRelationParticipantList[i1].selectedContactFieldEmailID = matchRole;
                  } else {
                    this.projectGroups[i].projGrpRelationParticipantList[i1].selectedContactFieldEmailID = [];
                  }
                }
              }
              else {
              }
            }
          }

          if (this.projectGroups.length > 0) {
            this.ProjectIdForEdit = this.projectGroups[0].projectID;
            this.projectID = this.projectGroups[0].projectID;
          }

          var data = [];
          data = this.projectGroups;
          if (data.length > 0) {
            this.eventLogMessage = "Sent for signature to ";
            var checkGroup = this.projectGroups.filter(m => m.groupType == GroupType.Group);
            if (checkGroup.length > 0) {
              var projGrpRelationParticipantList = [];
              projGrpRelationParticipantList = checkGroup[0].projGrpRelationParticipantList;
              for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                var checkEmailAnonmous = projGrpRelationParticipantList[i1].contactEmail;
                var checkEmail = projGrpRelationParticipantList[i1].participantEmail;
                var email = "";
                if (checkEmailAnonmous != "") {
                  email = checkEmailAnonmous;
                  this.eventLogMessage += '(' + email + '), ';
                }
                if (checkEmail != "") {
                  email = checkEmail;
                  this.eventLogMessage += '(' + email + '), ';
                }
              }
            }

            var checkViewOnly = this.projectGroups.filter(m => m.groupType == GroupType.ViewOnly);
            if (checkViewOnly.length > 0) {
              for (var i = 0, len4 = checkViewOnly.length; i < len4; ++i) {
                var projGrpRelationParticipantList = [];
                projGrpRelationParticipantList = checkViewOnly[i].projGrpRelationParticipantList;
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                  var checkEmailAnonmous = projGrpRelationParticipantList[i1].contactEmail;
                  var checkEmail = projGrpRelationParticipantList[i1].participantEmail;
                  var email = "";
                  if (checkEmailAnonmous != "") {
                    email = checkEmailAnonmous;
                    this.eventLogMessage += '(' + email + '), ';
                  }
                  if (checkEmail != "") {
                    email = checkEmail;
                    this.eventLogMessage += '(' + email + '), ';
                  }
                }
              }
            }
          }

          this.eventLogMessage = this.eventLogMessage?.replace(/,\s*$/, "") || "";

          var check = [];
          if (this.responseHolder.data.participants == null) {
            this.responseHolder.data.participants = [];
          }
          check = this.responseHolder.data.participants.filter((x:any) => x.groupType === GroupType.Group);//this.responseHolder.data.filter((x:any) => x.groupType === 1);
          if (check.length > 0) {
            for (var i = 0, len = check.length; i < len; ++i) {
              var projGrpRelationParticipantList = [];
              projGrpRelationParticipantList = check[i].projGrpRelationParticipantList;
              if (projGrpRelationParticipantList.length > 0) {
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                  if (projGrpRelationParticipantList[i1].participantEmail == null) {
                    projGrpRelationParticipantList[i1].participantEmail = '';
                  }
                  if (projGrpRelationParticipantList[i1].coreID > 0 || projGrpRelationParticipantList[i1].contactID > 0 ||
                    projGrpRelationParticipantList[i1].companyID > 0 || projGrpRelationParticipantList[i1].pUserID > 0 ||
                    projGrpRelationParticipantList[i1].roleID > 0 || projGrpRelationParticipantList[i1].participantEmail != '') {
                    // if (projGrpRelationParticipantList[i1].contactEmail != "" ||
                    //   projGrpRelationParticipantList[i1].participantEmail != "" ||
                    //   projGrpRelationParticipantList[i1].roleID != "0") {
                    this.SendButtonDisabled = true;
                    return;
                  } else {
                    this.SendButtonDisabled = false;
                    // return;
                  }
                }
              }
              else {
              }
            }
          }
        } else {
          this.loaderService.hide();
          this.projectGroups = [];
        }
      } else {
        this.loaderService.hide();
        this.projectGroups = [];
      }
    });

  }

  peoples: any = [];
  groupID: number;
  groupType: any;
  groupRelationParticipantMappingID: number;
  relationColour: string = '';
  relationID: number;
  isShare: boolean = false;
  contactemail: any;
  currentRoleContact: any;
  transRoleList: any = [];
  type: number = 0;
  searchValues: string = "";

  onSelectContact(event, relationName, p, p1) {
    if (event.value == p.participantName) {
      this.toastr.warning('Contact already added.', '', {
        timeOut: 3000,
      });
      return;
    }
    var getdata = this.MatchingRole.filter((s) => s.name == event.value && s.roleName == relationName);
    if (getdata.length > 0) {
      this.groupRelationParticipantMappingID = p.groupRelationParticipantMappingID;
      this.groupID = p.groupID;
      this.relationColour = "";
      this.projectID = p1.projectID;
      this.contactemail = p.contactEmail;
      this.relationID = p.relationID;
      this.peoples = [];

      this.peoples.push({
        name: getdata[0].name,
        email: getdata[0].email,
        img: "",
        coreID: 0,
        companyID: 0,
        contactID: getdata[0].contactID,
        roleID: 0,
        isShared: this.isShare,
        shortName: "",
        typeOfParticipant: 2,
      });
      if (this.peoples.length > 0) {
        this.addUpdateParticipantsNew(this.peoples);
      }
    }
  }

  isSharedAccessRolePopup: boolean = false;
  isRolePopup: boolean = false;
  contactsList: any = [];
  selectedsharedAccessRole: any = [];
  showAddButton = false;
  Module: string;
  showAddContact: boolean = false;
  sharedAccessRoleList: any = [];
  SharedRoleList: any = [];
  Roles: any = [];
  showContactRoleAddButton = false;
  documentId: number;
  coreID: any;
  isReviewerPopup: boolean = true;
  selectedUser: boolean = false;
  userSelectedList: any = [];
  isSharedAccessUserPopup: boolean = false;
  sharedAccessUserList: any = [];

  addUpdateParticipantsNew(result) {
    this.peoples = [];
    this.peoples = result;

    //=== For Email ======//
    if (result[0].typeOfParticipant == 0) {
      if (this.peoples.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var req = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID: 0,
            contactID: 0,
            companyID: 0,
            contactEmail: this.peoples[i].email,
            selectedContactFieldEmailID: 0,
            relationID: this.relationID,
            relationColour: this.relationColour,
            projectID: this.projectID,
            emailFieldID: 0,
            nameFieldID: 0,
            roleID: 0,
            userID: 0,
            typeOfParticipant: 0,//this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(req)
        }

        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: this.type,
          OfficeID: this.myOfficeID
        }
        this.loaderService.show();
        this.coreService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {
              this.AddRemoveParticipant(this.getassign);
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();
            }
          }
        });
      }
    }

    //=== For User ======//
    if (result[0].typeOfParticipant == 4) {
      if (this.peoples.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var reqUser = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID: 0,
            contactID: 0,
            companyID: 0,
            contactEmail: this.peoples[i].email,
            selectedContactFieldEmailID: 0,
            relationID: this.relationID,
            relationColour: this.relationColour,
            projectID: this.projectID,
            emailFieldID: 0,
            nameFieldID: 0,
            roleID: 0,
            userID: this.peoples[i].userID,
            typeOfParticipant: 4//this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(reqUser)
        }

        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: this.type,
          OfficeID: this.myOfficeID
        }
        this.loaderService.show();
        this.coreService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {
              this.AddRemoveParticipant(this.getassign);
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();
            }
          }
        });
      }
    }

    //=== For Role ======//
    if (result[0].typeOfParticipant == 5) {
      if (this.peoples.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var reqRole = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID: 0,
            contactID: 0,
            companyID: 0,
            contactEmail: null,
            selectedContactFieldEmailID: 0,
            relationID: this.relationID,
            relationColour: this.relationColour,
            projectID: this.projectID,
            emailFieldID: 0,
            nameFieldID: 0,
            userID: 0,
            roleID: this.peoples[i].roleID,
            typeOfParticipant: 5//this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(reqRole)
        }

        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: this.type,
          OfficeID: this.myOfficeID
        }
        this.loaderService.show();
        this.coreService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {
              this.AddRemoveParticipant(this.getassign);
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();
            }
          }
        });
      }
    }

    //=== For Core ======//
    if (result[0].typeOfParticipant == 1) {
      if (this.peoples.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var reqCore = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID: this.peoples[i].coreID,
            contactID: 0,
            companyID: 0,
            contactEmail: this.peoples[i].email,
            selectedContactFieldEmailID: 0,
            relationID: this.relationID,
            relationColour: this.relationColour,
            projectID: this.projectID,
            emailFieldID: 0,
            nameFieldID: 0,
            roleID: 0,
            userID: 0,
            typeOfParticipant: 1//this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(reqCore)
        }

        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: this.type,
          OfficeID: this.myOfficeID
        }
        this.loaderService.show();
        this.coreService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {
              this.AddRemoveParticipant(this.getassign);
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();
            }
          }
        });
      }
    }

    //=== For Contact ======//
    if (result[0].typeOfParticipant == 2) {
      if (this.peoples.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var reqContact = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID: 0,
            contactID: this.peoples[i].contactID,
            companyID: 0,
            contactEmail: this.peoples[i].email,
            selectedContactFieldEmailID: 0,
            relationID: this.relationID,
            relationColour: this.relationColour,
            projectID: this.projectID,
            emailFieldID: 0,
            nameFieldID: 0,
            roleID: 0,
            userID: 0,
            typeOfParticipant: 2//this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(reqContact)
        }

        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: this.type,
          OfficeID: this.myOfficeID
        }
        this.loaderService.show();
        this.coreService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {
              this.AddRemoveParticipant(this.getassign);
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();
            }
          }
        });
      }
    }

    //=== For Company ======//
    if (result[0].typeOfParticipant == 3) {
      if (this.peoples.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var reqCompany = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID: 0,
            contactID: 0,
            companyID: this.peoples[i].companyID,
            contactEmail: this.peoples[i].email,
            selectedContactFieldEmailID: 0,
            relationID: this.relationID,
            relationColour: this.relationColour,
            projectID: this.projectID,
            emailFieldID: 0,
            nameFieldID: 0,
            roleID: 0,
            userID: 0,
            typeOfParticipant: 3//this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(reqCompany)
        }

        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: this.type,
          OfficeID: this.myOfficeID
        }
        this.loaderService.show();
        this.coreService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {
              this.AddRemoveParticipant(this.getassign);
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();
            }
          }
        });
      }
    }
  }

  objectList: any = [];
  typeOfParticipant: number = 0;
  showContact: boolean = true
  showRole: boolean = false;
  showSearchCore: boolean = false;
  selectCoreList: any = [];
  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;
  stateCtrlValue: string;
  states = this.objectList;

  assignUserNew(isShare: boolean, isRole: boolean, contact: any, p, p1) {
    this.contactemail = "";
    this.showContact = true;
    this.showSearchCore = false;
    this.selectCoreList = [];

    this.isSharedAccessUserPopup = false;
    this.userSelectedList = [];
    this.sharedAccessUserList = [];

    this.stateCtrl.setValue('');

    this.typeOfParticipant = p.typeOfParticipant;
    this.type = p1.type;
    if (p1.projectID == 0) {
      this.projectID = Number(this.ProjectIdForEdit);
    } else {
      this.projectID = p1.projectID;
    }

    this.groupRelationParticipantMappingID = p.groupRelationParticipantMappingID;
    this.groupID = p.groupID;
    this.relationColour = p.relationColour;
    this.relationID = p.relationID;
    this.showAddButton = false;
    this.isShare = isShare;
    this.contactemail = p.contactEmail;
    this.isRolePopup = isRole;
    this.isSharedAccessRolePopup = false;
    if (isRole)
    this.currentRoleContact = contact;
    this.transRoleList = [];
    this.contactsList = [];
    this.Roles = [];
    this.peoples = [];
    this.selectedsharedAccessRole = [];
    this.showContactRoleAddButton = false;

    const dialogRef = this.dialog.open(Add3ctypeformComponent, {
      data: {
        moduleName: "coredocument",
        typeOfParticipant: this.typeOfParticipant
      },
      panelClass: 'signatureModal',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.addUpdateParticipantsNew(result);
      }
    });
  }


}


